import { Modal } from "antd";
import React, { useState } from "react";
import styled from "styled-components";
import { AddTokens } from "./AddTokens";
import { useStore } from "@stores/root-store";
import { useUserContext } from "@components/layout/superadmin-layout/SuperAdminLayout";

interface Props {
  isOpen?: boolean;
  closeModal?: (args: { fetchUserDetails: boolean }) => void;
  user: any;
}

export const AddTokensModal: React.FC<Props> = ({
  isOpen,
  closeModal,
  user,
}) => {
  const { updateUserDetails } = useUserContext();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [feature, setFeature] = useState<"chat" | "assistant">("chat");

  function handleCloseModal(params: { fetchUserDetails: boolean }) {
    setNewCredits(10);
    setFeature("chat");
    closeModal(params);
  }

  const {
    user: { addPurchasedTokens },
  } = useStore(null);

  const [newCredits, setNewCredits] = useState(10);

  const handlePurchaseTokens = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    const payload = {
      email: user.email,
      tool: feature,
      new_credits: newCredits,
    };

    await addPurchasedTokens(payload).then((res) => {
      if (res) {
        updateUserDetails();
        handleCloseModal({ fetchUserDetails: true });
      }
    });
    setIsSubmitting(false);
  };

  const decreaseValue = () => {
    setNewCredits((prev) => (prev <= 10 ? 0 : prev - 10));
  };

  const increaseValue = () => {
    setNewCredits((prev) => prev + 10);
  };

  return (
    <Wrapper>
      <Modal
        onCancel={() => handleCloseModal({ fetchUserDetails: false })}
        open={isOpen}
        className={"customKeywordModal"}
        width={721}
        closable={false}
        footer={null}
      >
        <AddTokens
          closeModal={handleCloseModal}
          user={user}
          setNewValue={setNewCredits}
          newCredits={newCredits}
          decreaseValue={decreaseValue}
          increaseValue={increaseValue}
          onConfirm={handlePurchaseTokens}
          isSubmitting={isSubmitting}
          feature={feature}
          setFeature={setFeature}
        />
      </Modal>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  .customKeywordModal {
    position: relative;

    .rc-dialog-content {
      .rc-dialog-close {
        color: #fff;
        font-size: 40px;
        right: -50px;
        top: -14px;
      }
    }
  }
`;
